export default __webpack_public_path__ + "static/media/profile_black.4ee9b275.svg";